import { PaymentProcessor } from "@zapier/payment/esm/types";

class PaymentProcessorFailedInitializationError extends Error {
  title = "Something's not quite right.";
  description =
    "We're having some trouble connecting to our payment processor. Please wait a few minutes, refresh the page, and try again.";

  constructor(paymentProcessor: PaymentProcessor) {
    super(`Payment processor "${paymentProcessor}" failed to initialize`);
  }
}

export { PaymentProcessorFailedInitializationError };
